import { STORE_CONSTANTS } from '../actionTypes'
import { apiService } from '../../store/middleware/service'
import { HELPER, HISTORY, CONSTANTS } from '../../utils'

export const storeAction = {
	STORES_LISTING,
	RESET_CATALOG_DOMAIN,

	SET_VISIBLE_STORE_LISTING,
	UPDATE_CURRENT_STORE_LISTING_PAGE,
	CLEAR_PAGE_NUMBER,
	LOAD_MORE_STORES,
}

function STORES_LISTING() {
	return (dispatch) => {
		dispatch(request())
		apiService
			.storesListing()
			.then((response) => {
				const responseStatus = response?.status
				if (!HELPER.isEmpty(responseStatus) && responseStatus === CONSTANTS.HTTP_RESPONSE.SUCCESS) {
					let dataList = response?.data
					dispatch(success(dataList))
				}
			})
			.catch((error) => {
				dispatch(failure(error))
			})
	}

	function request() {
		return { type: STORE_CONSTANTS.SHOP_LISTING_REQUEST }
	}
	function success(data) {
		return { type: STORE_CONSTANTS.SHOP_LISTING_SUCCESS, response: data }
	}
	function failure(error) {
		return { type: STORE_CONSTANTS.SHOP_LISTING_FAILURE, error }
	}
}

function SET_VISIBLE_STORE_LISTING() {
	return (dispatch, getState) => {
		// grab current state
		const { allStores, pageIndex, pageNumber } = getState().store
		if (!HELPER.isEmpty(allStores) && allStores.length > 0) {
			const indexOfLastProduct = pageNumber * pageIndex
			const indexOfFirstProduct = indexOfLastProduct - pageIndex
			const calcPageCount = Math.ceil(allStores.length / pageIndex)
			const visibleProducts = allStores.slice(indexOfFirstProduct, indexOfLastProduct)
			dispatch(request(visibleProducts, calcPageCount))
		}
	}

	function request(stores, totalPageCount) {
		return { type: STORE_CONSTANTS.UPDATE_STORE_LISTING_PAGE, response: { stores, totalPageCount } }
	}
}

function UPDATE_CURRENT_STORE_LISTING_PAGE(pageNum) {
	return (dispatch, getState) => {
		// grab current state
		let { allStores, pageIndex, pageNumber, stores } = getState().store
		pageNumber = pageNum ? pageNum : stores.length === 0 ? pageNumber : pageNumber + 1
		if (!HELPER.isEmpty(allStores) && allStores.length > 0) {
			const indexOfLastProduct = pageNumber * pageIndex
			const indexOfFirstProduct = indexOfLastProduct - pageIndex
			const pageCount = Math.ceil(allStores.length / pageIndex)
			const storesListing = allStores.slice(indexOfFirstProduct, indexOfLastProduct)
			dispatch(success(storesListing, pageCount, pageNumber))
		}
	}

	function success(stores, pageCount, pageNumber) {
		return {
			type: STORE_CONSTANTS.UPDATE_VISIBLE_STORE_PAGE_INDEX,
			response: { stores, pageCount, pageNumber },
		}
	}
}

function RESET_CATALOG_DOMAIN(catalogue_key) {
	return (dispatch) => {
		dispatch(request(catalogue_key))
		HISTORY.push('/' + catalogue_key)
	}
	function request(catalogue_key) {
		return { type: STORE_CONSTANTS.ACCESS_NEW_STORE, response: { catalogue_key } }
	}
}

function CLEAR_PAGE_NUMBER() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: STORE_CONSTANTS.CLEAR_PAGE_NUMBER }
	}
}

function LOAD_MORE_STORES() {
	return (dispatch) => {
		dispatch(request())
	}
	function request() {
		return { type: STORE_CONSTANTS.LOAD_MORE_STORES }
	}
}
